<template>
  <div class="customer-filter">
    <a-row>
      <a-col :span="22">
        <a-form-model layout="inline" :form="filterForm" :model="filterForm">
          <a-form-model-item label="标题">
            <a-input v-model="filterForm.name" allow-clear placeholder="需求标题" class="form-model-item" style="width: 150px" @change="onSearch" />
          </a-form-model-item>
          <a-form-model-item label="评审结果">
            <a-select v-model="filterForm.result" mode="multiple" allow-clear placeholder="选择评审结果" style="width: 150px" @change="onSearch">
              <a-select-option v-for="(item, index) in reviewItemResults" :key="index" :value="item.value">
                <a-tag v-if="item.value !== 5" :color="item.color">{{ item.label }}</a-tag>
                <a-tag v-else :color="item.color" style="color: gray; width: 40px">{{ item.label }}</a-tag>
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-form-model>
      </a-col>
      <a-col :span="2">
        <div style="margin-bottom: 10px; padding-right: 5px; float: right; margin-top: 3px">
          <a-button v-tc="{ name: '关联需求' }" type="primary" icon="plus" style="margin-right: 3px" @click="onAddStory()">关联需求 </a-button>
        </div>
      </a-col>
    </a-row>

    <a-table :scroll="{ x: 1300 }" :pagination="pagination" :columns="columns" :data-source="tableData" :loading="loading" row-key="id" :row-selection="showRowSelection" @change="handleTableChange">
      <span slot="name" slot-scope="text, record">
        <a-tooltip placement="top" :title="record.name">
          <a class="custom-link" @click="onDetail(record)"> {{ record.name }} </a>
        </a-tooltip>
      </span>
      <span slot="id" slot-scope="text, record">
        <span>PR-{{ record.id }}</span>
      </span>
      <span slot="result" slot-scope="text, record">
        <review-case-result-edit :disabled="resultDisabled" :review-id="reviewId" :case-id="record.id" :result="record.result" @change="getStoryList" />
      </span>
      <span slot="reviewer" slot-scope="text, record">{{ record.reviewer ? record.reviewer.nickname : '--' }}</span>
      <span slot="reviewTime" slot-scope="text, record">
        {{ record.review_time !== '' ? record.review_time : '--' }}
      </span>
      <span slot="progress" slot-scope="text, record">
        <a-progress :percent="record.progress" size="small" style="width: 120px" />
      </span>
    </a-table>
    <review-story-detail :display="detailVisible" :review-id="reviewId" :has-next="hasNext" :has-before="hasBefore" :story-id="storyId" @close="close" @next="loadNextStory" @before="loadBeforeStory" />
  </div>
</template>

<script>
import { reviewItemResults } from '@/utils/dictionary';
import { reviewRelatedStories } from '@/api/project/review';

import ReviewStoryDetail from '@/pages/project/review/components/ReviewStoryDetail';
import ReviewCaseResultEdit from '@/pages/project/review/components/ReviewCaseResultEdit';

const columns = [
  {
    key: 'selection-column',
    align: 'center',
    width: 20
  },
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'key',
    width: 80,
    ellipsis: true,
    sorter: true,
    scopedSlots: { customRender: 'id' }
  },
  {
    title: '名称',
    dataIndex: 'name',
    width: 250,
    ellipsis: true,
    sorter: true,
    scopedSlots: { customRender: 'name' }
  },
  {
    title: '评审结果',
    dataIndex: 'result',
    width: 80,
    ellipsis: true,
    sorter: true,
    scopedSlots: { customRender: 'result' }
  },
  // {
  //   title: '评审进度',
  //   width: 170,
  //   align: 'center',
  //   dataIndex: 'progress',
  //   scopedSlots: {customRender: 'progress'}
  // },
  {
    title: '评审人员',
    width: 120,
    align: 'center',
    dataIndex: 'reviewer',
    ellipsis: true,
    sorter: true,
    scopedSlots: { customRender: 'reviewer' }
  },
  {
    title: '评审时间',
    width: 170,
    align: 'center',
    dataIndex: 'review_time',
    scopedSlots: { customRender: 'reviewTime' }
  }
];
export default {
  name: 'ReviewStoryList',
  components: { ReviewCaseResultEdit, ReviewStoryDetail },
  props: {
    reviewId: {
      type: [Number, String],
      default: null
    },
    resultDisabled: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      columns,
      reviewItemResults,
      pagination: {
        size: 'large',
        total: 0,
        current: 1,
        pageSize: 20, // 每页中显示20条数据
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'], // 每页中显示的数据
        showTotal: total => `共 ${total} 条` // 分页中显示总的数据
      },
      tableData: [],
      storyData: {},
      loading: false,
      detailVisible: false,
      storyId: null,
      projectId: parseInt(this.$route.params.project_id) || null,
      nextStoryId: null,
      hasNext: false,
      beforeStoryId: null,
      hasBefore: false,
      selectedRowKeys: [],
      filterForm: {
        name: '',
        result: []
      },
      sorter: {
        sort_field: null,
        sort: null
      }
    };
  },
  computed: {
    getUser() {
      return user => {
        return user === null ? '--' : user.nickname;
      };
    },
    showRowSelection() {
      return { selectedRowKeys: this.selectedRowKeys, onChange: this.onSelectChange };
    }
  },
  watch: {
    planId: {
      immediate: true,
      handler(val) {
        if (val != null) {
          // this.reviewId = val;
          this.getStoryList();
        }
      }
    }
  },
  created() {
    this.getStoryList();
  },
  methods: {
    onAddStory() {
      this.$emit('add-story');
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    onSearch() {
      this.pagination.current = 1;
      this.pagination.pageSize = 10;
      this.getStoryList();
    },
    // 查看用例详情
    onDetail(record) {
      this.storyId = record.id;
      this.detailVisible = true;
      this.storyData = record;
      this.findNextStory();
      this.findBeforeStory();
    },
    findNextStory() {
      const index = this.tableData.findIndex(row => row.id === this.storyId);
      if (index !== this.tableData.length - 1) {
        this.nextStoryId = this.tableData[index + 1].id;
        this.hasNext = true;
      } else {
        if (!this.hasNextPage()) {
          this.nextStoryId = null;
          this.hasNext = false;
        } else {
          this.nextStoryId = -1;
          this.hasNext = true;
        }
      }
    },
    findBeforeStory() {
      const index = this.tableData.findIndex(row => row.id === this.storyId);
      if (index !== 0 && index < this.tableData.length) {
        this.beforeStoryId = this.tableData[index - 1].id;
        this.hasBefore = true;
      } else {
        if (!this.hasBeforePage()) {
          this.beforeStoryId = null;
          this.hasBefore = false;
        } else {
          this.beforeStoryId = -1;
          this.hasBefore = true;
        }
      }
    },
    hasNextPage() {
      const pageNumber = this.pagination.current;
      const total = this.pagination.total;
      if (pageNumber * this.pagination.pageSize < total) {
        return true;
      }
      return false;
    },
    hasBeforePage() {
      const pageNumber = this.pagination.current;
      if (pageNumber > 1) {
        return true;
      }
      return false;
    },
    handleTableChange(pagination, _, sorter) {
      this.pagination = pagination;
      this.sorter.sort_field = sorter.field;
      this.sorter.sort = sorter.order === 'ascend' ? 'asc' : 'desc';
      this.getStoryList();
    },
    close() {
      this.storyId = null;
      this.storyData = {};
      this.detailVisible = false;
      this.getStoryList();
      this.$emit('refresh');
    },
    // 获取用例列表
    getStoryList() {
      this.loading = true;
      reviewRelatedStories({
        ...this.filterForm,
        ...this.sorter,
        result: this.filterForm.result.length > 0 ? this.filterForm.result : null,
        project_id: this.projectId,
        review_id: this.reviewId,
        page_number: this.pagination.current,
        page_size: this.pagination.pageSize
      })
        .then(res => {
          this.tableData = res.data.items;
          this.pagination.total = res.data.total;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getStoryListPromise() {
      return reviewRelatedStories({
        ...this.filterForm,
        ...this.sorter,
        result: this.filterForm.result.length > 0 ? this.filterForm.result : null,
        project_id: this.projectId,
        review_id: this.reviewId,
        page_number: this.pagination.current
      });
    },
    loadNextStory() {
      if (this.nextStoryId != null) {
        if (this.nextStoryId !== -1) {
          this.storyId = this.nextStoryId;
          this.findNextStory();
          this.findBeforeStory();
        } else {
          this.pagination.current += 1;
          if (this.pagination.current > Math.ceil(this.pagination.total / this.pagination.pageSize)) {
            return;
          }
          this.getStoryListPromise().then(res => {
            this.tableData = res.data.items;
            if (this.tableData.length > 0) {
              this.storyId = this.tableData[0].id;
            }
            this.findNextStory();
            this.findBeforeStory();
          });
        }
      }
    },
    loadBeforeStory() {
      if (this.beforeStoryId != null) {
        if (this.beforeStoryId !== -1) {
          this.storyId = this.beforeStoryId;
          this.findNextStory();
          this.findBeforeStory();
        } else {
          this.pagination.current -= 1;
          this.getStoryListPromise().then(res => {
            this.tableData = res.data.items;
            if (this.tableData.length > 0) {
              this.storyId = this.tableData[this.tableData.length - 1].id;
            }
            this.findNextStory();
            this.findBeforeStory();
          });
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .customer-filter {
  .ant-page-header {
    padding: 0;
  }

  .ant-form-item {
    margin-bottom: 8px;
    display: inline-block !important;

    .ant-form-item-control-wrapper {
      flex: 1;
    }
  }

  .filter-right {
    float: right;
    text-align: right;
  }

  .customer-date-picker {
    width: calc(50% - 3px);
  }
}

/deep/ .ant-table-tbody > tr > td {
  padding: 8px 8px;
}

/deep/ .ant-table-thead > tr > th {
  padding: 8px 8px;
}

.handle-menu {
  margin: 0 4px;
}

.custom-link {
  color: rgba(0, 0, 0, 0.65);
}

.custom-link:hover {
  color: #1890ff;
}

.handle-button {
  margin-left: 8px;
}
</style>
